



















import TableCell from './TableCell.vue'
import { LoadTypeName } from '@/services/models/marketplace-service-model'
export default {
  components: {
    TableCell
  },
  props: {
    needsPalletExchange: { type: Boolean, required: true },
    loadType: { type: String, default: '' },
    palletQuantity: { type: Number, default: 0 },
    hSpan: { type: Number, default: 4 }
  },
  computed: {
    loadTypeName() {
      return LoadTypeName[this.loadType]
    }
  }
}
